export const CarBuyStatusEnum = Object.freeze({
    confirmed: 'confirmed',
    fastDelivery: 'fast_delivery',
    listing: 'listing',
    inTransit: 'in_transit',
});